import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { AvatarComponent } from '../avatar/avatar.component';
import { AuthenticationService, ContextUserService } from '../../../services';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { PipesModule } from '../../pipes';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    AvatarComponent,
    MatTooltipModule,
    PipesModule,
    NgbDropdownModule,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  private _userContext = inject(ContextUserService);
  private router = inject(Router);
  private readonly _spinner = inject(NgxSpinnerService);
  private authenticationService= inject(AuthenticationService);

  public user: any | null = null;
  public profiles: any[] | null = null;
  public profilePrincipal: number = 0;

  get profileNames(): string {
    return (
      this.profiles
        ?.map((p: any) => p.prName)
        .filter((name: any) => name)
        .join(' - ') || ''
    );
  }
// este era el de antes 
  // get gerProfilePrincipal(): string {
  //   const pf = this.profiles?.find(p => p.prId == this.profilePrincipal);
  //   return pf?.prName || 'Sin Perfil Principal';
  // }

  get gerProfilePrincipal(): string {
    const currentUser = JSON.parse(localStorage.getItem('currentUserCr') || '{}');
    return currentUser?.rol?.rol_nombre || 'Sin Perfil Principal';
  }
  get inicialesUsuario(): string {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const first = currentUser?.firstName?.charAt(0) || '';
    const last = currentUser?.lastName?.charAt(0) || '';
    return `${first}${last}`.toUpperCase();
  }

  ngOnInit() {
    this.user = this._userContext?.getUser?.user || null;
    this.profiles = this._userContext?.getUser?.profiles || null;
    this.initProfile();
  }

  initProfile() {
    this._userContext.watch('user').subscribe((user: any) => {
      if (!user) return;

      this.profiles = (user.profiles ?? []);
      console.log("this.profiles: ", this.profiles)
    });

    this._userContext.watchActiveProfileId().subscribe(prId => {
      if (!prId) return;
      this.profilePrincipal = prId;
    });
  }

  selectProfile(profileId: number) {
    if (!profileId) return;

    this._userContext.setActiveProfileId(profileId);
    this.router.navigate(['/home']);
  }


  logout() {
    this._spinner.show();
    console.log('Iniciando proceso de logout...');
    const url = this.authenticationService.logout();
    this._spinner.hide();
  }
  getData() {

  }
}
